module.exports = __webpack_public_path__ + "assets/img/e0c6b3d829f7f6dbd361660b454f8ee8.png";